/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { GeneralService } from './services/general.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  // generalData: any;

  constructor(private analytics: AnalyticsService, public _General: GeneralService) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();


    // // OBTENEMOS LOS DATOS GENERICOS PARA EL USUARIO
    // this._General.onGeneralUpdated().subscribe((data) => {
    //   if (data == null) {
    //     this.generalData = [];
    //   }else {
    //     this.generalData = data;
    //   }
    // });
    // this.generalData = [];
    // this._General.getData();

    // DEFINIMOS UNA COOKIE GLOBAL CON EL TIMEZONE
    this.setCookieTz('tz', new Date().getTimezoneOffset(), 10);

    this.setCookie('language', 'es', 10);
  }

  setCookie(name: string, value, days: number) {
    const d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + '=' + value + '; path=/;expires=' + d.toUTCString();
  }


    setCookieTz(name: string, value, days: number) {
      const d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + '=' + value + '; path=/;expires=' + d.toUTCString();
    }
}




